export default {"src":"/_next/static/image/src/images/Icons/phone.ea837f8bda9acc609b47d69d993c0944.svg","height":21,"width":11};